import { isCommentInvoiceLine } from "../utils/commentInvoiceLines";
import { isCalculatedPricing, projectCalculatedCustomerLine } from "../utils/calculatedPricing";
const RETAIL_ESTIMATE_REPORT_CONTENT = `
<html>
<head>
  <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
  <style>
    @page { size: Letter; }
    * { box-sizing: border-box; }
    html, body {
      margin: 0;
      padding: 0;
      color: #172033;
      font-family: Arial, Helvetica, sans-serif;
      font-size: 9.5pt;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
    table { width: 100%; border-collapse: collapse; }
    tr { page-break-inside: avoid; page-break-after: auto; }
    .top-table { margin-bottom: 12px; }
    .top-table td { vertical-align: top; padding: 0; border: none; }
    .report-title {
      text-align: right;
      font-size: 23pt;
      font-weight: 700;
      color: #17324d;
      line-height: 1;
      margin-bottom: 5px;
      text-transform: uppercase;
    }
    .not-invoice {
      text-align: right;
      color: #667085;
      font-size: 9pt;
      font-weight: 700;
      letter-spacing: .25px;
      margin-bottom: 8px;
    }
    .pricing-mode {
      width: max-content;
      margin: 0 0 8px auto;
      padding: 3px 8px;
      border-radius: 999px;
      background: #fff3e0;
      color: #b45309;
      font-size: 7.5pt;
      font-weight: 700;
      letter-spacing: .35px;
    }
    .meta-table { width: auto; margin-left: auto; border-collapse: collapse; }
    .meta-table td {
      padding: 2px 0 2px 14px;
      font-size: 8.5pt;
      white-space: nowrap;
      border: none;
    }
    .label {
      color: #667085;
      font-weight: 700;
      text-transform: uppercase;
      font-size: 7.5pt;
      letter-spacing: .25px;
    }
    .value { font-weight: 700; color: #172033; }
    .rule { border-top: 2px solid #17324d; margin: 0 0 10px 0; }
    .summary-table {
      border-collapse: separate;
      border-spacing: 6px 0;
      table-layout: fixed;
      margin: 0 -6px 10px -6px;
    }
    .summary-table td {
      border: 1px solid #d8e0ea;
      border-radius: 4px;
      padding: 7px 9px;
      background: #fbfcfe;
      vertical-align: top;
    }
    .summary-customer-cell { width: 56%; }
    .summary-cell { width: 22%; }
    .summary-value, .summary-customer {
      font-size: 12pt;
      font-weight: 700;
      color: #17324d;
      margin-top: 2px;
      line-height: 1.15;
      overflow-wrap: break-word;
    }
    .customer-panel {
      border: 1px solid #d8e0ea;
      border-radius: 4px;
      padding: 8px 10px;
      margin-bottom: 10px;
      background: #fff;
    }
    .panel-title {
      font-weight: 700;
      color: #17324d;
      border-bottom: 1px solid #e4eaf1;
      padding-bottom: 4px;
      margin-bottom: 6px;
      text-transform: uppercase;
      font-size: 8pt;
      letter-spacing: .25px;
    }
    .line { line-height: 1.3; font-size: 9.5pt; }
    .estimate {
      border: 1px solid #d8e0ea;
      border-radius: 4px;
      overflow: visible;
      margin-top: 10px;
      page-break-inside: auto;
      break-inside: auto;
    }
    .estimate-header {
      background: #17324d;
      color: #fff;
      padding: 8px 10px;
      page-break-inside: avoid;
      break-inside: avoid;
    }
    .estimate-title {
      color: #fff;
      font-size: 10.5pt;
      font-weight: 700;
      line-height: 1.25;
      overflow-wrap: break-word;
    }
    .estimate-notes {
      padding: 8px 10px 2px 10px;
      background: #fff;
      border-bottom: 1px solid #d8e0ea;
    }
    .note-block { margin-bottom: 8px; page-break-inside: avoid; break-inside: avoid; }
    .note-title {
      color: #17324d;
      font-weight: 700;
      font-size: 8pt;
      text-transform: uppercase;
      letter-spacing: .25px;
      margin-bottom: 3px;
    }
    .note-text {
      white-space: pre-wrap;
      line-height: 1.35;
      font-size: 9.5pt;
      color: #172033;
    }
    table.lines { table-layout: fixed; }
    table.lines thead { display: table-header-group; }
    table.lines th {
      background: #eef3f8;
      color: #263445;
      text-transform: uppercase;
      font-size: 7.5pt;
      letter-spacing: .25px;
      border-bottom: 1px solid #cfd8e3;
      padding: 5px 8px;
      text-align: left;
    }
    table.lines td {
      padding: 5px 8px;
      border-bottom: 1px solid #e5ebf2;
      vertical-align: top;
      line-height: 1.3;
      font-size: 9.5pt;
    }
    table.lines tr:nth-child(even) td { background: #fafbfd; }
    .desc { overflow-wrap: anywhere; word-break: break-word; }
    .qty { text-align: center; white-space: nowrap; }
    .num { text-align: right; white-space: nowrap; }
    .estimate-total {
      width: 100%;
      background: #f7f9fc;
      padding: 7px 10px;
      text-align: right;
      color: #17324d;
      font-size: 11pt;
      font-weight: 700;
      page-break-inside: avoid;
      break-inside: avoid;
    }
  </style>
</head>
<body>
  <div class="page">
    <table class="top-table">
      <tr>
        <td>
          <div class="report-title">Estimates</div>
          <div class="not-invoice">NOT AN INVOICE</div>
          <div class="pricing-mode">RETAIL PRICING</div>
          <table class="meta-table">
            <tr><td class="label">Job ID</td><td class="value">{{>invoiceId}}</td></tr>
            <tr><td class="label">Date</td><td class="value">{{>date}}</td></tr>
            <tr><td class="label">Estimates</td><td class="value">{{>jobCount}}</td></tr>
          </table>
        </td>
      </tr>
    </table>

    <div class="rule"></div>

    <table class="summary-table">
      <tr>
        <td class="summary-customer-cell">
          <div class="label">Customer</div>
          <div class="summary-customer">{{>customerName}}</div>
        </td>
        <td class="summary-cell">
          <div class="label">Estimates Count</div>
          <div class="summary-value">{{>jobCount}}</div>
        </td>
        <td class="summary-cell">
          <div class="label">Date</div>
          <div class="summary-value">{{>date}}</div>
        </td>
      </tr>
    </table>

    <div class="customer-panel">
      <div class="panel-title">Customer</div>
      <div class="line value">{{>customerName}}</div>
    </div>

    {{for instances}}
      <div class="estimate">
        <div class="estimate-header"><div class="estimate-title">{{>estimateName}}</div></div>

        {{if jobDescription || instructions || notes}}
          <div class="estimate-notes">
            {{if jobDescription}}
              <div class="note-block">
                <div class="note-title">Job Description</div>
                <div class="note-text">{{>jobDescription}}</div>
              </div>
            {{/if}}
            {{if instructions}}
              <div class="note-block">
                <div class="note-title">Instructions</div>
                <div class="note-text">{{>instructions}}</div>
              </div>
            {{/if}}
            {{if notes}}
              <div class="note-block">
                <div class="note-title">Notes</div>
                <div class="note-text">{{>notes}}</div>
              </div>
            {{/if}}
          </div>
        {{/if}}

        <table class="lines">
          <thead>
            <tr>
              <th>Description</th>
              <th style="width:46px;text-align:center;">Qty</th>
              <th style="width:82px;text-align:right;">Rate</th>
              <th style="width:86px;text-align:right;">Total</th>
            </tr>
          </thead>
          <tbody>
            {{for invoiceItems}}
              <tr>
                <td class="desc">{{>description}}{{if note}}<div style="white-space:pre-wrap">{{>note}}</div>{{/if}}</td>
                <td class="qty">{{>qty}}</td>
                <td class="num">{{>rate}}</td>
                <td class="num">{{>total}}</td>
              </tr>
            {{/for}}
          </tbody>
        </table>

        <div class="estimate-total">{{>total}}</div>
      </div>
    {{/for}}
  </div>
</body>
</html>`;

export const RETAIL_ESTIMATE_JSREPORT_TEMPLATE = {
	engine: "jsrender",
	recipe: "chrome-pdf",
	content: RETAIL_ESTIMATE_REPORT_CONTENT,
	chrome: {
		printBackground: true,
		marginTop: ".5in",
		marginRight: ".33in",
		marginBottom: ".5in",
		marginLeft: ".33in",
		preferCSSPageSize: true
	}
};

function toText(value) {
	return value === undefined || value === null ? "" : String(value).trim();
}

function toFiniteNumber(value, fallback = 0) {
	if (value === undefined || value === null || (typeof value === "string" && value.trim() === "")) {
		return fallback;
	}
	const parsed = Number(value);
	return Number.isFinite(parsed) ? parsed : fallback;
}

function roundCurrency(value) {
	return Math.round((toFiniteNumber(value, 0) + Number.EPSILON) * 100) / 100;
}

function formatCurrency(value) {
	return `$${roundCurrency(value).toFixed(2)}`;
}

function formatDate(value) {
	const date = value instanceof Date ? value : new Date(value);
	if (Number.isNaN(date.getTime())) {
		return "";
	}
	return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
}

function buildRetailEstimateLine(invoiceItem = {}) {
	if (isCommentInvoiceLine(invoiceItem)) return { lineType: "comment", lineId: invoiceItem.lineId, description: toText(invoiceItem.description || invoiceItem.desc), note: toText(invoiceItem.note), qty: "", rate: "", total: "", totalNumber: 0 };
	if (isCalculatedPricing(invoiceItem)) {
		const publicLine = projectCalculatedCustomerLine(invoiceItem);
		return { description: toText(publicLine.description || publicLine.desc), qty: "", rate: "", total: publicLine.amountRequired ? "Amount required" : formatCurrency(publicLine.value), totalNumber: publicLine.value || 0 };
	}
	const qty = toFiniteNumber(invoiceItem.qty, 1);
	const rate = toFiniteNumber(invoiceItem.rate, 0);
	const discount = toFiniteNumber(invoiceItem.discount, 1);
	const rateAfterDiscount = roundCurrency(rate * discount);
	const total = roundCurrency(qty * rateAfterDiscount);
	const discountLabel = discount < 1
		? ` (${((1 - discount) * 100).toFixed(0)}% qty discount)`
		: "";

	return {
		description: `${toText(invoiceItem.description || invoiceItem.desc)}${discountLabel}`,
		qty,
		rate: formatCurrency(rateAfterDiscount),
		total: formatCurrency(total),
		totalNumber: total
	};
}

function buildRetailEstimateInstance(instance = {}) {
	const invoiceItems = (Array.isArray(instance.invoiceItems) ? instance.invoiceItems : [])
		.map(buildRetailEstimateLine);
	const total = roundCurrency(invoiceItems.reduce((sum, item) => sum + item.totalNumber, 0));

	return {
		instanceId: toText(instance.instanceId),
		estimateId: toText(instance.estimateId),
		estimateName: toText(instance.estimateName || instance.name) || "Estimate",
		jobDescription: toText(instance.jobDescription || instance.description),
		instructions: toText(instance.instructions),
		notes: toText(instance.jobNotes || instance.notes),
		invoiceItems: invoiceItems.map(item => ({
			...(item.lineType === "comment" ? { lineType: "comment", lineId: item.lineId, note: item.note } : {}),
			description: item.description,
			qty: item.qty,
			rate: item.rate,
			total: item.total
		})),
		total: formatCurrency(total),
		totalNumber: total
	};
}

export function buildRetailEstimateReportData({
	invoiceId = "",
	customerName = "",
	instances = [],
	generatedAt = new Date()
} = {}) {
	const normalizedCustomerName = toText(customerName);
	if (!normalizedCustomerName) {
		throw new Error("Customer Name (jobNumber) is required for a retail estimate.");
	}

	const normalizedInstances = (Array.isArray(instances) ? instances : [])
		.map(buildRetailEstimateInstance);

	return {
		reportMode: "retail",
		invoiceId: toText(invoiceId),
		customerName: normalizedCustomerName,
		date: formatDate(generatedAt),
		jobCount: normalizedInstances.length,
		instances: normalizedInstances
	};
}
